import Base from './action-base'
import renderFields from './disable-playbook.pug'

export default class DisablePlaybook extends Base
  Object.defineProperty this, "label", get: -> @t(".label")
  @icon = "fa-ban"

  @DEFAULTS:
    message: ""
    retryMessage: ""

  renderFields: renderFields
